import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowLeftX: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowLeftX"><Path fillRule="evenodd" clipRule="evenodd" d="M7.35617 4L1.83893 12L7.35617 20H22V4H7.35617ZM11.2483 8.93934L13.25 10.941L15.2517 8.93934L16.3123 10L14.3107 12.0017L16.3107 14.0017L15.25 15.0623L13.25 13.0623L11.25 15.0623L10.1893 14.0017L12.1893 12.0017L10.1877 10L11.2483 8.93934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowLeftX;
